import * as React from "react";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
const TextAreaRows = (props) => {
  return /* @__PURE__ */ React.createElement(
    PropsChecker,
    {
      componentProps: props,
      componentName: "TextareaRows",
      defaultValueName: "defaultRows",
      valueName: "rows",
      onChangeNames: "onChange",
      isComponentDisabled: props.isDisabled || props.isReadOnly
    },
    /* @__PURE__ */ React.createElement(
      PropsChecker,
      {
        componentProps: props,
        componentName: "TextareaRows",
        defaultValueName: "defaultIsFocused",
        valueName: "isFocused",
        onChangeNames: ["onFocus", "onBlur"]
      },
      /* @__PURE__ */ React.createElement(TextAreaRowsInner, { ...props })
    )
  );
};
class TextAreaRowsInner extends React.Component {
  constructor(props) {
    super(props);
    this.textarea = null;
    this.magicalCharacter = "‌";
    this.prevSelectionStart = 0;
    this.prevSelectionEnd = 0;
    this.windowDidResize = () => {
      this.setState({
        txtRows: this.getTxtRows(this.rows)
      });
    };
    this.onFocus = () => {
      const done = () => {
        if (this.props.onFocus) {
          this.props.onFocus();
        }
      };
      if (this.props.isReadOnly) {
        return done();
      }
      if (typeof this.props.isFocused === "undefined") {
        this.setState({
          isFocused: true
        });
      }
      done();
    };
    this.onBlur = () => {
      if (typeof this.props.isFocused === "undefined") {
        this.setState({
          isFocused: false
        });
      }
      if (this.props.onBlur) {
        this.props.onBlur();
      }
    };
    this.onKeyUp = (event) => {
      this.skipHelper(event.keyCode);
    };
    this.onClick = () => {
      this.skipHelper();
    };
    this.onChange = (event) => {
      if (!this.textarea) {
        return;
      }
      this.prevSelectionStart = this.textarea.selectionStart;
      this.prevSelectionEnd = this.textarea.selectionEnd;
      const strings = event.target.value.split("\n");
      const rowValues = strings.filter((item) => item !== this.magicalCharacter);
      if (typeof this.props.rows === "undefined") {
        const rows = this.rowsCheckForHelpers(this.rows, rowValues);
        this.setState({ rows });
      }
      if (this.props.onChange) {
        this.props.onChange(rowValues);
      }
    };
    this.autosize = () => {
      if (this.textarea) {
        this.textarea.style.height = "auto";
        this.textarea.style.height = "".concat(this.textarea.scrollHeight, "px");
      }
    };
    this.state = {
      isFocused: props.defaultIsFocused || false,
      rows: this.defaultRows.map(({ value }) => ({ value })),
      // Exclude helpers for SSR
      txtRows: this.getTxtRows(this.defaultRows)
    };
    this.textareaClonedRows = [];
    this.textareaClonedRowsHelper = [];
  }
  componentDidMount() {
    window.addEventListener("resize", this.windowDidResize);
    if (typeof this.props.rows === "undefined") {
      this.setState({
        rows: this.defaultRows
      });
    } else {
      this.setState({
        txtRows: this.getTxtRows(this.defaultRows)
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.windowDidResize);
  }
  componentDidUpdate(prevProps, prevState) {
    let prevRows = this.props.onChange && typeof this.props.rows !== "undefined" ? prevProps.rows : prevState.rows;
    if (this.props.isDisabled || this.props.isReadOnly) {
      prevRows = typeof this.props.rows !== "undefined" ? prevProps.rows : prevState.rows;
    }
    if (this.rows !== prevRows) {
      this.setState(
        {
          txtRows: this.getTxtRows(this.rows)
        },
        () => {
          if (!this.textarea) {
            return;
          }
          this.textarea.selectionStart = this.prevSelectionStart;
          this.textarea.selectionEnd = this.prevSelectionEnd;
        }
      );
    }
    if (prevState.txtRows !== this.state.txtRows) {
      this.autosize();
    }
  }
  get defaultRows() {
    if (this.props.onChange && typeof this.props.rows !== "undefined") {
      return this.props.rows;
    } else if (typeof this.props.defaultRows !== "undefined") {
      return this.props.defaultRows;
    }
    return [];
  }
  get rows() {
    if (this.props.isReadOnly || this.props.isDisabled) {
      return typeof this.props.rows !== "undefined" ? this.props.rows : this.state.rows;
    }
    return this.props.onChange && typeof this.props.rows !== "undefined" ? this.props.rows : this.state.rows;
  }
  get isFocused() {
    if (this.props.isReadOnly || this.props.isDisabled) {
      return typeof this.props.isFocused !== "undefined" ? this.props.isFocused : this.state.isFocused;
    }
    return this.props.onBlur && this.props.onFocus && typeof this.props.isFocused !== "undefined" ? this.props.isFocused : this.state.isFocused;
  }
  get isInvalid() {
    var _a;
    return (_a = this.props.isInvalid) != null ? _a : !!this.props.errorMessage;
  }
  BEM() {
    const classArray = ["textarea-rows"];
    if (this.rows.length) {
      classArray.push("is-dirty");
    }
    if (this.rows.length > 9999) {
      classArray.push("is-wide");
    }
    if (this.props.isDisabled) {
      classArray.push("is-disabled");
    }
    if (this.isInvalid) {
      classArray.push("is-invalid");
    }
    if (this.isFocused) {
      classArray.push("is-focused");
    }
    if (this.props.hideLabel) {
      classArray.push("textarea-rows--no-label-" + this.props.hideLabel);
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  itemBEM(helper) {
    const classArray = ["textarea-rows__item"];
    if (helper && helper.type) {
      classArray.push("textarea-rows__item--".concat(helper.type));
    }
    return classArray.join(" ");
  }
  rowsCheckForHelpers(oldRows, newRowValues) {
    const oldRowValues = oldRows.map((row) => row.value);
    return newRowValues.map((value) => {
      const oldRowValuesIndex = oldRowValues.indexOf(value);
      if (oldRowValuesIndex !== -1) {
        const helper = oldRows[oldRowValuesIndex].helper;
        if (oldRows[oldRowValuesIndex].value === value) {
          return { value, helper };
        }
      }
      return { value };
    });
  }
  skipHelper(keyCode) {
    if (!this.textarea) {
      return;
    }
    const currLineIndex = this.textarea.value.substr(0, this.textarea.selectionStart).split("\n").length - 1;
    if (this.state.txtRows[currLineIndex] === this.magicalCharacter) {
      if (keyCode === 40) {
        this.textarea.selectionStart = this.textarea.selectionEnd = this.textarea.selectionStart + 2;
      } else {
        this.textarea.selectionStart = this.textarea.selectionEnd = this.textarea.selectionStart - 2;
      }
      this.skipHelper(keyCode);
    }
  }
  getTxtRows(rows) {
    if (!rows.length) {
      return [];
    }
    return rows.reduce((acc, curr, index) => {
      acc.push(curr.value);
      if (this.textareaClonedRowsHelper) {
        const rowHelper = this.textareaClonedRowsHelper[index];
        if (rowHelper) {
          const rowHeight = this.textareaClonedRows[index].getBoundingClientRect().height;
          const rowTextComputedStyles = window.getComputedStyle(rowHelper, null);
          if (rowTextComputedStyles.height) {
            const rowTextHeight = +rowTextComputedStyles.height.split("px")[0];
            if (rowTextHeight < Math.floor(rowHeight) && rowTextComputedStyles.lineHeight) {
              const rowTextLineHeight = +rowTextComputedStyles.lineHeight.split("px")[0];
              const realRowTextHeight = Math.round(rowTextHeight / rowTextLineHeight) * rowTextLineHeight;
              const newRows = Math.floor(realRowTextHeight / rowTextLineHeight);
              for (let i = 0; i < newRows; i += 1) {
                acc.push(this.magicalCharacter);
              }
            }
          }
        }
      }
      return acc;
    }, []);
  }
  getHelper(helper, key) {
    return /* @__PURE__ */ React.createElement("div", { className: "textarea-rows__helper", ref: (div) => this.textareaClonedRowsHelper[key] = div }, /* @__PURE__ */ React.createElement(FormHelper, { className: "textarea-rows__item-helper", ...helper }));
  }
  getClonedRow(row, key) {
    this.textareaClonedRowsHelper[key] = null;
    return /* @__PURE__ */ React.createElement("div", { className: this.itemBEM(row.helper), key, ref: (div) => this.textareaClonedRows[key] = div }, /* @__PURE__ */ React.createElement("div", { className: "textarea-rows__item-nr" }, key + 1), /* @__PURE__ */ React.createElement("div", { className: "textarea-rows__item-text" }, /* @__PURE__ */ React.createElement("div", { className: "textarea-rows__value" }, row.value), row.helper && this.getHelper(row.helper, key)));
  }
  getClonedRows() {
    const rows = this.rows.map((row, key) => {
      return this.getClonedRow(row, key);
    });
    return /* @__PURE__ */ React.createElement("div", { className: "textarea-rows__items" }, rows);
  }
  getAriaDescribedBy() {
    const arr = [];
    if (this.props.helpMessage) {
      arr.push("".concat(this.props.id, "-help-message"));
    }
    if (this.props.errorMessage) {
      arr.push("".concat(this.props.id, "-error-message"));
    }
    if (this.props.successMessage) {
      arr.push("".concat(this.props.id, "-success-message"));
    }
    if (this.props.employeeMessage) {
      arr.push("".concat(this.props.id, "-employee-message"));
    }
    return arr.join(" ");
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM() }, /* @__PURE__ */ React.createElement("label", { htmlFor: this.props.id, className: "textarea-rows__label" }, this.props.label), this.props.helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.helpMessage, type: "help", id: "".concat(this.props.id, "-help-message") }), this.props.errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.errorMessage, type: "error", id: "".concat(this.props.id, "-error-message") }), this.props.successMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.successMessage, type: "valid", id: "".concat(this.props.id, "-success-message") }), this.props.employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.employeeMessage, type: "employee", id: "".concat(this.props.id, "-employee-message") }), /* @__PURE__ */ React.createElement("div", { className: "textarea-rows__main" }, /* @__PURE__ */ React.createElement("div", { className: "textarea-rows__inner" }, /* @__PURE__ */ React.createElement("div", { className: "textarea-rows__mirror" }, this.rows && this.getClonedRows()), /* @__PURE__ */ React.createElement(
      "textarea",
      {
        ...this.props.input,
        id: this.props.id,
        readOnly: this.props.isReadOnly,
        className: "textarea-rows__input",
        rows: this.state.txtRows.length,
        ref: (textarea) => this.textarea = textarea,
        value: this.state.txtRows && this.state.txtRows.join("\n"),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onKeyUp: this.onKeyUp,
        onClick: this.onClick,
        disabled: this.props.isDisabled,
        "aria-invalid": this.isInvalid,
        "aria-describedby": this.getAriaDescribedBy()
      }
    ))));
  }
}
export {
  TextAreaRows,
  TextAreaRowsInner
};
